import tippy from 'tippy.js';

const tippyDirective = () => ({
  restrict: 'A',
  scope: {
    content: '@',
    arrow: '<?',
    animation: '<?',
    trigger: '@',
    theme: '@',
  },
  link: (scope, element) => {
    tippy(element[0], {
      content: scope.content,
      arrow: scope.arrow,
      animation: scope.animation || 'fade',
      trigger: scope.trigger || 'mouseenter',
      theme: scope.theme || 'dark',
    });
  },
});

export default tippyDirective;
